import { ErrorPage } from "sj-ui-toolkit/src/atlas/components/ErrorPage/ErrorPage";
import { AdminAppRoutes } from "sj-ui-toolkit/src/constants/routes";

export default function NotFound() {
  return (
    <div className="atlas-bg-home min-h-screen">
      <ErrorPage
        redirectRoute={AdminAppRoutes.route}
        buttonText="Go to Dashboard"
        automaticRedirect={false}
      />
    </div>
  );
}
